/*
 * @Description  :
 * @Version      : 1.0.0
 * @Author       : Luoye
 * @Date         : 2023-11-30 16:03:06
 * @LastEditors  : Luoye
 * @FilePath     : /namibox_client_web/src/common/components/message/components/ConfirmBox/index.tsx
 * Copyright (C) 2023 rose. All rights reserved.
 */
import React, { useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import usePreventTouchMove from 'SRC/common/hooks/usePreventTouchMove';
import styles from './styles.scss';

type Fn = () => void;
interface BaseProps {
  title: React.ReactNode;
  subTitle: React.ReactNode;
  domWrap: HTMLDivElement;
  okBtnText?: string;
  cancelBtnText?: string;
  className?: string;
  okCallback?: Fn;
  cancelCallback?: (arg?: string) => void;
  onClose?: Fn;
}

const ConfirmBox: React.FC<BaseProps> = (props) => {
  const {
    title,
    subTitle,
    domWrap,
    className,
    okBtnText,
    cancelBtnText,
    okCallback,
    cancelCallback,
    onClose,
  } = props;
  const [forceReRender, setForceReRender] = useState(false);
  const maskDomRef = useRef<HTMLDivElement>();
  // 禁止mask滑动
  usePreventTouchMove(maskDomRef.current as HTMLDivElement);
  function canfirmFn() {
    if (domWrap) {
      ReactDOM.unmountComponentAtNode(domWrap);
      document.body.removeChild(domWrap);
      onClose && onClose();
    }
    okCallback && okCallback();
  }

  function cancelFn(type?: string) {
    if (domWrap) {
      ReactDOM.unmountComponentAtNode(domWrap);
      document.body.removeChild(domWrap);
      onClose && onClose();
    }
    cancelCallback && cancelCallback(type);
  }
  return (
    <div
      className={styles['mask-wrap']}
      ref={(ele) => {
        if (ele) {
          maskDomRef.current = ele;
          setForceReRender(!!ele);
        }
      }}
    >
      <div className={styles['confirm-content-wrapper']}>
        <div className={`${styles['confirm-content']} ${className}`}>
          <h3 className={styles['title']}>{title}</h3>
          <div className={`${styles['sub-title']} confirm-content-subtitle`}>
            {subTitle}
          </div>
          <div
            className={`${styles['btn-group']}  confirm-modal-button-wrapper`}
          >
            <div
              className={`${styles['confirm-btn']} confirm-modal-cancel-button`}
              onClick={() => {
                cancelFn('cancel');
              }}
            >
              {cancelBtnText}
            </div>
            <div
              className={`${styles['confirm-btn']} ${styles['active']} confirm-modal-ok-button`}
              onClick={canfirmFn}
            >
              {okBtnText}
            </div>
          </div>
          <div
            className={styles['close-icon']}
            onClick={() => {
              cancelFn('close');
            }}
          />
        </div>
      </div>
    </div>
  );
};

ConfirmBox.defaultProps = {
  okBtnText: '确定',
  cancelBtnText: '取消',
};

export default ConfirmBox;
